// Copy-paste snippets for the "Share & embed" tab. Text is generated with the
// real public origin (publicOrigin()) + shop id substituted, so what the shop
// pastes into their website works verbatim. Keep the iframe/widget shapes in
// lockstep with src/pages/consumer-embed.tsx (resize message contract) and
// public/etx-intake.js (floating-button script attributes).

// Website iframe + the auto-height listener. The listener filters on origin,
// message type AND shop id so a page embedding two shops' forms can't
// cross-resize them.
export function iframeSnippet(
  origin: string,
  shopId: number | string,
  shopName: string,
): string {
  const frameId = `etx-intake-${shopId}`
  return [
    `<iframe id="${frameId}" src="${origin}/embed/${shopId}?src=embed&utm_source=website"`,
    `  title="Get an estimate from ${shopName}"`,
    `  style="display:block;width:100%;max-width:560px;height:720px;border:0;border-radius:16px"`,
    `  allow="camera; microphone" loading="lazy"></iframe>`,
    `<script>window.addEventListener("message",function(e){if(e.origin!=="${origin}")return;var m=e.data||{};if(m.type!=="etx-intake:resize"||String(m.shopId)!=="${shopId}")return;var f=document.getElementById("${frameId}");if(f&&m.height>0)f.style.height=Math.ceil(m.height)+"px";});</script>`,
  ].join("\n")
}

// Floating "Get an estimate" button — one script tag, configured by data
// attributes. public/etx-intake.js reads its own src for the origin.
export function widgetSnippet(
  origin: string,
  shopId: number | string,
  color: string,
): string {
  return `<script src="${origin}/etx-intake.js?v=1" data-shop="${shopId}" data-color="${color}" data-label="Get an estimate" data-position="right" async></script>`
}

// Shown under both snippets — the one hosting gotcha a shop's web person
// will actually hit.
export function cspNote(origin: string): string {
  return `If your site uses a Content-Security-Policy, allow ${origin} in frame-src (and script-src for the button).`
}

// Filesystem-safe slug from the shop name — QR/PDF download filenames.
export function shopSlug(shopName: string): string {
  return (
    shopName
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "") || "shop"
  )
}

// Clipboard write that reports success instead of throwing — callers decide
// on the toast. execCommand fallback covers non-secure LAN dev origins.
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    try {
      const ta = document.createElement("textarea")
      ta.value = text
      ta.setAttribute("readonly", "")
      ta.style.position = "fixed"
      ta.style.opacity = "0"
      document.body.appendChild(ta)
      ta.select()
      const ok = document.execCommand("copy")
      ta.remove()
      return ok
    } catch {
      return false
    }
  }
}
